"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const rxjs_1 = require("rxjs");
const widget_1 = require("../widget");
class LoginRequest {
    constructor() {
        this.firebaseUser$ = new rxjs_1.Subject();
    }
}
exports.LoginRequest = LoginRequest;
class LoginWidget extends widget_1.Widget {
    constructor() {
        super(...arguments);
        this.loginRequest = new LoginRequest();
    }
    close() {
        this.loginRequest.firebaseUser$.complete();
    }
}
exports.LoginWidget = LoginWidget;
